import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=44a15c02&"
import script from "./FormComponent.vue?vue&type=script&lang=ts&"
export * from "./FormComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports